<template>
    <div id="banner-servicios" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item" v-for="(slider, index) in sliders" :key="index"
                v-bind:class="{ active: index == 0 }">
                <img :src="slider.image_slide" style="width:100%;" alt="Servicios Redautos" />
                <div class="carousel-caption">
                    <div class="banner_text text-center div_zindex white-text">
                        <h1 class="text-white">{{ slider.title_slide }}</h1>
                        <h3 class="text-white">{{ slider.subtitle_slide }}</h3>
                        <div class="html-slide" v-html="slider.html_slide"></div>
                    </div>
                </div>
            </div>
        </div>

        <a class="carousel-control-prev" href="#banner-servicios" role="button" data-slide="prev"
            aria-label="Deslizar a la diapositiva anterior">
            <span class="carousel-control-prev-icon"></span>
        </a>
        <a class="carousel-control-next" href="#banner-servicios" role="button" data-slide="next"
            aria-label="Deslizar a la diapositiva siguiente">
            <span class="carousel-control-next-icon"></span>
        </a>
    </div>
</template>

<script>
export default {
    props: ["sliders"]
};
</script>

<style lang="scss">
#banner2 .carousel-item:after {
    background: rgba(255, 255, 255, 0) none repeat scroll 0 0;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

a.btn.dark {
    background: #222222 !important;
}

a#btn-md {
    padding: 0.8rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
}

a.btn.btn-outline-dark {
    color: #343a40;
    border-color: #343a40 !important;
    background: none;
    border: 1px solid transparent;
    background-color: transparent;
}

.banner_text {
    max-width: 600px;
    margin: 0 auto;
}

.banner_text h1 {
    font-size: clamp(2rem, 3.5vw, 3.2rem);
    line-height: 1.1;
    word-break: break-word;
}

.banner_text h3 {
    font-size: clamp(1.1rem, 2vw, 1.7rem);
    line-height: 1.3;
    word-break: break-word;
}

.carousel-caption {
    bottom: 20%;
}

@media (max-width: 1400px) {
    .banner_text {
        max-width: 480px;
    }

    .banner_text h1 {
        font-size: 2rem;
        line-height: 1.15;
        max-width: 420px;
        margin: 0 auto;
    }

    .banner_text h3 {
        font-size: 1.05rem;
        line-height: 1.3;
        max-width: 420px;
        margin: 12px auto 0;
    }

    .banner_text .html-slide {
        max-width: 420px;
        margin: 12px auto 0;
    }

    .banner_text .html-slide a {
        font-size: 0.95rem;
        padding: 0.6rem 0.9rem;
    }
}

@media (max-width: 1200px) {
    .banner_text {
        max-width: 520px;
    }
}

@media (max-width: 992px) {
    .banner_text {
        max-width: 460px;
    }

    .banner_text h1 {
        font-size: 2.1rem;
    }

    .banner_text h3 {
        font-size: 1.2rem;
    }
}

@media (max-width: 768px) {
    .banner_text {
        max-width: 90%;
    }

    .banner_text h1 {
        font-size: 1.6rem;
        line-height: 1.15;
    }

    .banner_text h3 {
        font-size: 1rem;
        line-height: 1.25;
    }
}

@media (max-width: 576px) {
    .banner_text h1 {
        font-size: 1.35rem;
        line-height: 1.2;
    }

    .banner_text h3 {
        font-size: 0.95rem;
        line-height: 1.3;
    }
}
</style>
